import { action, makeObservable, observable } from 'mobx';
import ApiService from '../../services/ApiService';
import { InvoiceLineUsageRow } from '../models/InvoiceLineUsageRow';
import { Loadable } from '../models/Loadable';

export default class InvoiceLineUsagesDataStore {
  @observable
  private usagesByInvoiceAndLineId = new Map<string, Map<string, Loadable<InvoiceLineUsageRow[]>>>();

  constructor(private apiService: ApiService) {
    makeObservable(this);
  }

  @action
  public tryLoadInvoiceLineUsages(invoiceNumber: string, lineId: string, source: string, customerId: number): void {
    if (!this.usagesByInvoiceAndLineId.has(invoiceNumber)) {
      this.usagesByInvoiceAndLineId.set(invoiceNumber, observable(new Map()));
    }

    const usagesByLineId = this.usagesByInvoiceAndLineId.get(invoiceNumber);
    if (lineId != null && !usagesByLineId.has(lineId)) {
      this.loadLineUsages(invoiceNumber, lineId, source, customerId);
    }
  }

  public invoiceLineUsages(invoiceNumber: string, lineId: string): Loadable<InvoiceLineUsageRow[]> {
    if (!this.usagesByInvoiceAndLineId.has(invoiceNumber)) {
      return null;
    }
    return this.usagesByInvoiceAndLineId.get(invoiceNumber).get(lineId);
  }

  private loadLineUsages(invoiceNumber: string, lineId: string, source: string, customerId: number) {
    const invoiceLineUsages = Loadable.toLoadable<InvoiceLineUsageRow[], InvoiceLineUsageRow[]>(
      this.apiService.getInvoiceLineUsage(customerId, invoiceNumber, lineId, source)
    );
    this.usagesByInvoiceAndLineId.get(invoiceNumber).set(lineId, invoiceLineUsages);
  }
}
